export default function PrimaryButton({ children, className = "", ...rest }) {
  return (
    <button
      {...rest}
      className={`w-full rounded-xl bg-emerald-600 text-white font-semibold tracking-wide py-3 shadow-sm hover:bg-emerald-700 hover:shadow-md dark:bg-emerald-500 dark:hover:bg-emerald-400 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 ${className}`}
    >
      {children}
    </button>
  );
}
